import styled from 'styled-components';
import { Card, getSpacingToken, mediaMaxWidth } from '@optimus-web/core';
import { BreakpointRange } from '@mews-commander/ui';

export const BillCardLayout = styled(Card)`
    display: flex;
    ${mediaMaxWidth(BreakpointRange.Tablet.value)} {
        flex-direction: column;
    }
`;

export const MainContentElement = styled.div`
    width: 100%;
`;

export const BillCardSidebarElement = styled.div`
    display: flex;
    flex-grow: 1;
    padding: ${getSpacingToken('100')}px 0;
    & > :first-child {
        flex-grow: 1;
    }
    & > :last-child {
        margin: ${getSpacingToken('100')}px;
    }
`;
